import React from 'react';
import PropTypes from 'prop-types';
import { createGlucometria, getHistoricoGlucometria } from '../../../domain/api/MedicionesApi';
import { validarGlucometria } from '../../utils/HelpValidacionMediciones';
import {
	COLUMNAS_HISTORIAL_GLUCOMETRIA,
	NOTA_RANGOS_GLUCOMETRIA,
	RANGOS_SUGERIDOS_GLUCOMETRIA,
} from '../../utils/HelpMediciones';
import usePanelMedicion from './usePanelMedicion';
import useHistorialMedicion from './useHistorialMedicion';
import HistorialMediciones from './HistorialMediciones';
import PanelMedicion from './PanelMedicion';
import CampoMedicion from './CampoMedicion';
import RangosSugeridos from './RangosSugeridos';

const VALORES_INICIALES = { glucometria: '' };

/** Panel de registro de glucometría: solo configura el patrón de panel. */
const PanelGlucometria = ({ modulo, numeroDocumento, evbi, onRegistrado }) => {
	const historial = useHistorialMedicion({ cargar: getHistoricoGlucometria, numeroDocumento });
	const panel = usePanelMedicion({
		valoresIniciales: VALORES_INICIALES,
		validar: validarGlucometria,
		enviar: createGlucometria,
		numeroDocumento,
		evbi,
		onExito: () => {
			// Solo con codigoRespuesta '0000': usePanelMedicion no llama onExito en error
			historial.recargar();
			if (onRegistrado) {
				onRegistrado(modulo.id);
			}
		},
	});

	return (
		<PanelMedicion
			modulo={modulo}
			guardando={panel.guardando}
			bloqueado={panel.bloqueado}
			resultado={panel.resultado}
			onGuardar={panel.guardar}
			onLimpiar={panel.limpiar}
			pie={
				<HistorialMediciones
					id="glucometria"
					columnas={COLUMNAS_HISTORIAL_GLUCOMETRIA}
					historial={historial}
				/>
			}
		>
			<RangosSugeridos id="glucometria" rangos={RANGOS_SUGERIDOS_GLUCOMETRIA} nota={NOTA_RANGOS_GLUCOMETRIA} />
			<CampoMedicion
				id="medicion-glucometria"
				label="Glucometría"
				unidad="mg/dL"
				value={panel.valores.glucometria}
				onChange={(texto) => panel.setValor('glucometria', texto)}
				error={panel.errores.glucometria}
			/>
		</PanelMedicion>
	);
};

PanelGlucometria.propTypes = {
	modulo: PropTypes.shape({
		id: PropTypes.string.isRequired,
		label: PropTypes.string.isRequired,
		descripcion: PropTypes.string,
	}).isRequired,
	numeroDocumento: PropTypes.string,
	evbi: PropTypes.number,
	onRegistrado: PropTypes.func,
};

export default PanelGlucometria;
